import BaseRequest from "./BaseRequest";
import { API_URL } from "../config/config";

const AutoridadeAPI = () => {
    return {
        buscarDetalhesAutoridade(codAutoridade, cancelToken = null) {
            const options = { headers: BaseRequest.publicHeaders(), cancelToken };
            return BaseRequest.axiosInst.get(
                `${API_URL}/autoridade/${codAutoridade}`,
                options
            );
        },
        buscarDetalhesAutoridadeCombo: (autoridades, cancelToken = null) => {
            const options = { headers: BaseRequest.publicHeaders(), params: {autoridades}, cancelToken };
            return BaseRequest.axiosInst.get(
                `${API_URL}/autoridade/combo`,
                options
            );
        },
        getImages(cod_autoridade, limit = 0, cancelToken = null){
            const options = { headers: BaseRequest.publicHeaders(), params: {cod_autoridade, limit}, cancelToken };
            return BaseRequest.axiosInst.get(
                `${API_URL}/autoridade/get-images`,
                options
            );
        }
    };
};

export default AutoridadeAPI();
